import { useQuery } from '@tanstack/react-query';

import { fetchAdmins } from '../api/adminsApi';

export const ADMIN_ACCOUNTS_QUERY_KEY = ['admin', 'admins'] as const;

export function useAdminAccounts() {
  return useQuery({
    queryKey: ADMIN_ACCOUNTS_QUERY_KEY,
    queryFn: fetchAdmins,
  });
}
